// Utility to clear all cached data on logout
export function clearCacheOnLogout() {
  localStorage.removeItem('employees');
  localStorage.removeItem('substores');
  localStorage.removeItem('token');
  localStorage.removeItem('user');
}
